import React from 'react';
import StopIcon from './img/stop.svg';
import MovingIcon from './img/inMotion.svg';
import IdleIcon from './img/badgeNormalIdle.svg';
import IdleExcessiveIcon from './img/badgeExcessiveIdle.svg';
import IdleExcusableIcon from './img/badgeExcusableIdle.svg';
// import TemperedIcon from './img/tempered.svg';
import InTowIcon from './img/inTow.svg';
// import StandbyIcon from './img/standby.svg';
import MovementDetectedIcon from './img/badgeMovementDetected.svg';
import StandbyEVIcon from './img/badgeEVStandby.svg';
import StandbyHybridIcon from './img/badgeHybridStandby.svg';
import CrashIcon from './img/badgeCrash.svg';

const MotionState = (props) => {
  const { motionInference } = props;
// this to display markerImage;
  const motion = (value) => {
        switch (value) {
        case 100:
            return <img loading="lazy" src={StopIcon} alt="marker-icon" />;
        case 200:
            return <img loading="lazy" src={MovingIcon} alt="marker-icon" />;
        case 400:
            return <img loading="lazy" src={IdleIcon} alt="marker-icon" />;
        case 450:
            return <img loading="lazy" src={IdleExcessiveIcon} alt="marker-icon" />;
        case 460:
            return <img loading="lazy" src={IdleExcusableIcon} alt="marker-icon" />;
        case 300:
            return <img loading="lazy" src={InTowIcon} alt="marker-icon" />;
        case 150:
          return <img loading="lazy" src={MovementDetectedIcon} alt="marker-icon" />;
        case 800:
          return <img loading="lazy" src={StandbyEVIcon} alt="marker-icon" />;
        case 850:
          return <img loading="lazy" src={StandbyHybridIcon} alt="marker-icon" />;
        case 700:
          return <img loading="lazy" src={CrashIcon} alt="marker-icon" />;
        // case 500:
        //     return <img loading="lazy" src={TemperedIcon} alt="marker-icon" />;
        default:
            return null;
        }
  };
  return (
    <div>
        {motion(motionInference)}
    </div>
  );
};

export default MotionState;
